export const ACCESS_TOKEN = 'access-token' // token
export const USER_INFO = 'user-info'
export const THIRD_USER_INFO = 'third-user-info'
export const INDEX_PATH = '/home' // 主页路径
export const WHITE_PATHS = ['/payIframe'] // 白名单路径，在没有token时可以进入的页面



// WEBPACK FOOTER //
// ./src/store/mutation-types.js